export default __webpack_public_path__ + "static/media/numberTwo.2e786e67.svg";